import { Plugin } from "@segment/analytics-next";
import { EVENT_HELPER as EH } from "../../constants/EventHelper";
import LocalStorageService from "../../../../utils/LocalStorageService";

const SegmentInjectTraitsPlugin: Plugin = {
  name: 'SegmentInjectTraitsPlugin',
  type: 'enrichment',
  version: '1.0.0',

  isLoaded: () => true,
  load: () => Promise.resolve(),

  track: (ctx) => {
    if (ctx.event.type === 'identify') {
      return ctx
    }

    const temporaryUserTraits = LocalStorageService.getItem(EH.TEMPORARY_USER_TRAITS);
    const parsedTemporaryUserTraits = temporaryUserTraits ? JSON.parse(temporaryUserTraits) : null;
    ctx.updateEvent('context.traits', parsedTemporaryUserTraits)
    return ctx
  }
};

export default SegmentInjectTraitsPlugin;
